import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {StandingsDestinationDomainModel} from "./standings.destinations.domain-model";
import {BRIGHTNESS_BG_THRESHOLD} from "../../../../core/app/consts";
import {LIGHT_PALETTE, COLORS} from "../../../../core/app/consts/colors";

export class StandingsDestinationViewModel extends BaseViewModel {
  domainModel: StandingsDestinationDomainModel;
  winnerText: String;

  constructor(domainModel: StandingsDestinationDomainModel) {
    super(domainModel);

    this.winnerText = null;
  }


  get num(): Number {
    return this.domainModel.num;
  }

  get name(): String {
    return this.domainModel.name;
  }

  get guaranteedText(): String {
    return this.winnerText || this.domainModel.guaranteedText || this.name;
  }

  get color(): String {
    const color: String = this.domainModel.color.brightnessBgLevel(BRIGHTNESS_BG_THRESHOLD.default, LIGHT_PALETTE[COLORS.grayPrimary], this.domainModel.color) || 'transparent';

    return color;
  }

  get type(): Number {
    return this.domainModel.type;
  }
}